import { render, staticRenderFns } from "./LayoutList.vue?vue&type=template&id=58b8eb22&scoped=true&"
import script from "./LayoutList.vue?vue&type=script&lang=js&"
export * from "./LayoutList.vue?vue&type=script&lang=js&"
import style0 from "./LayoutList.vue?vue&type=style&index=0&id=58b8eb22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b8eb22",
  null
  
)

export default component.exports